import { ChangeDetectionStrategy, Component, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FilterAttributeRangeComponentDef } from '@df/catalog-ui/listing/filter/filter-attribute-range.component.def';
import { Model } from '@df/catalog/model';
import { ZippyModule } from '@df/legacy/ui/zippy/zippy.module';
import { RangeSliderChangeContext } from '@df/ui/form/range-slider/change-context';
import { RangeSliderOptions } from '@df/ui/form/range-slider/options';
import { RangeSliderModule } from '@df/ui/form/range-slider/range-slider.module';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
@Component({
    selector: 'filter-attribute-range',
    templateUrl: './filter-attribute-range.html',
    styleUrls: ['./filter-attribute-range.scss'],
    standalone: true,
    imports: [ZippyModule, TranslationModule, FormsModule, PriceComponent, RangeSliderModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterAttributeRangeComponent<T extends Model> extends FilterAttributeRangeComponentDef<T> {
    protected _rangeMin?: number;
    protected _rangeMax?: number;
    protected _min?: number;
    protected _max?: number;

    options: RangeSliderOptions = new RangeSliderOptions();

    zippyId() {
        return ['filter', this.filter.id];
    }

    get min(): number | undefined {
        return this._min || 0;
    }

    get max(): number | undefined {
        return this._max;
    }

    set rangeMin(value: number) {
        this._rangeMin = value;
        this._min = value;
    }

    get rangeMin() {
        return this._rangeMin || 0;
    }

    set rangeMax(value: number) {
        this._rangeMax = value;
        this._max = value;
    }

    get rangeMax() {
        return this._rangeMax || 0;
    }

    get minModel(): number | undefined {
        return this.filter.min;
    }

    set minModel(value: number | undefined) {
        this.filter.min = value;
    }

    get maxModel(): number | undefined {
        return this.filter.max;
    }

    set maxModel(value: number | undefined) {
        this.filter.max = value;
    }

    get label(): string | undefined {
        return this.filter.attribute.data?.label;
    }

    override get metaMax(): number {
        return this.filter?.getMetaData()?.max || 1000;
    }

    override get metaMin(): number {
        return this.filter?.getMetaData()?.min || 0;
    }

    override ngOnInit() {
        this.rangeMin = this.metaMin;
        this.rangeMax = this.metaMax;

        if (this.filter.hasSelection) {
            if (this.filter.selection?.min) {
                this.rangeMin = Math.max(this.metaMin, this.filter.selection.min);
                this.filter.min = this.rangeMin;
            }
            if (this.filter.selection?.max) {
                this.rangeMax = Math.min(this.metaMax, this.filter.selection.max);
                this.filter.max = this.rangeMax;
            }
        }

        this.updateOptions();
    }

    override ngOnChanges(changes: SimpleChanges) {
        if (!changes['options']) {
            this.updateOptions();
        }
    }

    onUserChange(event: RangeSliderChangeContext) {
        this.rangeMin = this._min = event.value;
        this.rangeMax = this._max = event.highValue || 0;
        this.detectChanges();
    }

    onUserChangeEnd(event: RangeSliderChangeContext) {
        if (this.filter) {
            this.filter.min = event.value;
            this.filter.max = event.highValue;
        }
    }

    protected updateOptions() {
        this.options = {
            floor: this.metaMin,
            ceil: this.metaMax,
            step: 0.01,
            hideLimitLabels: true,
            hidePointerLabels: true,
            outputEventsInterval: 50
        };
    }
}
